import {PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from '../../../constants/TextConst';

import {ColumnType, ColumnZoomType} from 'priority-web-sdk/enums';

export enum Operator {
    Contains,
    StartsWith,
    EndsWith,
    Between,
    Equals,
    NotEquals,
    Less,
    LessOrEqual,
    Greater,
    GreaterOrEqual,
    Later,
    Before,
    Empty,
    NotEmpty
}

export const OperatorMapping = {
    [Operator.Contains]: '=',
    [Operator.StartsWith]: '=',
    [Operator.EndsWith]: '=',
    [Operator.Equals]: '=',
    [Operator.NotEquals]: '<>',
    [Operator.Less]: '<',
    [Operator.LessOrEqual]: '<=',
    [Operator.Before]: '<',
    [Operator.Greater]: '>',
    [Operator.GreaterOrEqual]: '>=',
    [Operator.Later]: '>',
    [Operator.Between]: '',
    [Operator.Empty]: '=',
    [Operator.NotEmpty]: '<>'
};

export const RangeOperatorMapping = {
    '<': [Operator.Less],
    '<=': [Operator.LessOrEqual],
    '>': [Operator.Greater],
    '>=': [Operator.GreaterOrEqual],
    '=': [Operator.Equals],
    '<>': [Operator.NotEquals]
};

export const OperatorIconMapping = {
    [Operator.Contains]: {
        type: Operator.Contains,
        name: texts.contains,
        icon: PriorityIcon.operatorContains
    },
    [Operator.StartsWith]: {
        type: Operator.StartsWith,
        name: texts.startsWith,
        icon: PriorityIcon.operatorStartsWith
    },
    [Operator.EndsWith]: {
        type: Operator.EndsWith,
        name: texts.endsWith,
        icon: PriorityIcon.operatorEndsWith
    },
    [Operator.Between]: {
        type: Operator.Between,
        name: texts.between,
        icon: PriorityIcon.operatorSearchBetween
    },
    [Operator.Equals]: {
        type: Operator.Equals,
        name: texts.equals,
        icon: PriorityIcon.operatorEquals
    },
    [Operator.NotEquals]: {
        type: Operator.NotEquals,
        name: texts.notEquals,
        icon: PriorityIcon.operatorNotEquals
    },
    [Operator.Less]: {type: Operator.Less, name: texts.less, icon: PriorityIcon.operatorLess},
    [Operator.LessOrEqual]: {
        type: Operator.LessOrEqual,
        name: texts.lessOrEqual,
        icon: PriorityIcon.operatorLessAndEquals
    },
    [Operator.Greater]: {
        type: Operator.Greater,
        name: texts.greater,
        icon: PriorityIcon.operatorGrater
    },
    [Operator.GreaterOrEqual]: {
        type: Operator.GreaterOrEqual,
        name: texts.greaterOrEqual,
        icon: PriorityIcon.operatorGraterAndEquals
    },
    [Operator.Later]: {
        type: Operator.Later,
        name: texts.later,
        icon: PriorityIcon.operatorGrater
    },
    [Operator.Before]: {
        type: Operator.Before,
        name: texts.before,
        icon: PriorityIcon.operatorLess
    },
    [Operator.Empty]: {
        type: Operator.Empty,
        name: texts.EmptyOperator,
        icon: PriorityIcon.empty
    },
    [Operator.NotEmpty]: {
        type: Operator.NotEmpty,
        name: texts.NotEmptyOperator,
        icon: PriorityIcon.notEmpty
    }
};

export const ColumnTypeOptions = {
    [ColumnType.Text]: [
        Operator.Contains,
        Operator.Between,
        Operator.StartsWith,
        Operator.EndsWith,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Empty,
        Operator.NotEmpty
    ],
    [ColumnType.Date]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Later,
        Operator.Before,
        Operator.Empty,
        Operator.NotEmpty
    ],
    [ColumnType.Time]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Later,
        Operator.Before
    ],
    [ColumnType.Duration]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Less,
        Operator.LessOrEqual,
        Operator.Greater,
        Operator.GreaterOrEqual
    ],
    [ColumnType.Number]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Less,
        Operator.LessOrEqual,
        Operator.Greater,
        Operator.GreaterOrEqual
    ],
    [ColumnType.Bool]: [Operator.Equals, Operator.NotEquals],
    [ColumnZoomType.Choose]: [
        Operator.Equals,
        Operator.NotEquals,
        Operator.Contains,
        Operator.StartsWith,
        Operator.EndsWith,
        Operator.Empty,
        Operator.NotEmpty
    ],
    [ColumnZoomType.Search]: [
        Operator.Equals,
        Operator.NotEquals,
        Operator.Contains,
        Operator.StartsWith,
        Operator.EndsWith,
        Operator.Empty,
        Operator.NotEmpty
    ]
};

export const defaultOperators = {
    [ColumnType.Text]: Operator.Contains,
    [ColumnType.Date]: Operator.Between,
    [ColumnType.Time]: Operator.Between,
    [ColumnType.Duration]: Operator.Between,
    [ColumnType.Number]: Operator.Between,
    [ColumnType.Bool]: Operator.Equals,
    [ColumnZoomType.Choose]: Operator.Equals,
    [ColumnZoomType.Search]: Operator.Equals
};

export function columnOptionsDisplay({type, zoom}) {
    if (zoom && ColumnTypeOptions[zoom]) {
        return ColumnTypeOptions[zoom].map(option => OperatorIconMapping[option]);
    }
    return ColumnTypeOptions[type].map(option => OperatorIconMapping[option]);
}

export function getDefaultOperator({type, zoom}) {
    if (zoom && defaultOperators[zoom]) {
        return defaultOperators[zoom];
    }
    return defaultOperators[type];
}
